import React, { useState } from 'react';

const ImageCard = ({
  item,
  className = '',
  ...props
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [currentUrlIndex, setCurrentUrlIndex] = useState(0);

  // Handle image loading
  const handleImageLoad = () => {
    console.log('✅ Image loaded successfully:', displayImageUrl);
    setImageLoaded(true);
    setImageError(false);
  };

  // Handle image error
  const handleImageError = () => {
    const urls = getImageUrl();
    if (urls && currentUrlIndex < urls.length - 1) {
      console.log(`❌ Image failed to load: ${urls[currentUrlIndex]}, trying next URL...`);
      setCurrentUrlIndex(currentUrlIndex + 1);
      setImageError(false);
    } else {
      console.error('❌ All image URLs failed to load');
      setImageError(true);
      setImageLoaded(false);
    }
  };

  // Get the appropriate image URL with multiple fallback formats
  const getImageUrl = () => {
    if (item.imageUrl) {
      const driveId = item.imageUrl.match(/id=([a-zA-Z0-9-_]+)/);
      if (driveId) {
        const fileId = driveId[1];
        return [
          `https://drive.google.com/thumbnail?id=${fileId}&sz=w800`,
          `https://drive.google.com/thumbnail?id=${fileId}&sz=w400`,
          `https://drive.google.com/thumbnail?id=${fileId}&sz=w200`,
          `https://drive.google.com/uc?export=download&id=${fileId}`,
          `https://drive.google.com/file/d/${fileId}/preview`,
          `https://drive.google.com/uc?export=view&id=${fileId}`,
          item.imageUrl
        ];
      }
      return [item.imageUrl];
    }
    if (item.thumbnailUrl) return [item.thumbnailUrl];
    return null;
  };

  const urls = getImageUrl();
  const displayImageUrl = urls ? urls[currentUrlIndex] : null;

  const cardContent = (
    <div className={`overflow-hidden rounded-lg shadow-lg bg-white hover:shadow-xl transition-all duration-300 ${item.externalUrl ? 'cursor-pointer' : 'hover:-translate-y-1'} ${className}`} {...props}>
      <div className="relative">
        {item.category && (
          <div className="absolute top-3 left-3 bg-primary text-white px-3 py-1 rounded-full text-xs font-medium shadow-lg">
            {item.category}
          </div>
        )}

        {displayImageUrl ? (
          <img
            key={`${item.id || item.title}-${currentUrlIndex}`}
            src={displayImageUrl}
            alt={item.title || 'Gallery Image'}
            className={`w-full h-64 object-cover ${imageLoaded ? 'opacity-100' : 'opacity-0'}`}
            onLoad={handleImageLoad}
            onError={handleImageError}
          />
        ) : (
          <div className="w-full h-64 bg-gray-200 flex items-center justify-center">
            <span className="text-gray-500">No Image</span>
          </div>
        )}

        {!imageLoaded && !imageError && (
          <div className="absolute inset-0 bg-gray-100 flex items-center justify-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
          </div>
        )}

        {imageError && (
          <div className="absolute inset-0 bg-gray-100 flex items-center justify-center">
            <span className="text-red-500 text-sm">Image not available</span>
          </div>
        )}
      </div>

      <div className="py-3 px-4">
        <h3 className="text-lg font-semibold text-gray-800 mb-1 line-clamp-2">
          {item.title || 'Untitled Image'}
        </h3>

        {item.description && (
          <p className="text-gray-600 text-sm mb-3 line-clamp-3">
            {item.description}
          </p>
        )}

        {item.date && (
          <div className="flex items-center text-gray-500 text-xs">
            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2-2v14a2 2 0 002 2z" />
            </svg>
            {new Date(item.date).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'short',
              day: 'numeric'
            })}
          </div>
        )}
      </div>
    </div>
  );

  return item.externalUrl ? (
    <a href={item.externalUrl} target="_blank" rel="noreferrer noopener" className="block">
      {cardContent}
    </a>
  ) : (
    cardContent
  );
};

export default ImageCard;

